module.exports = __webpack_public_path__ + "img/wechat-pc-bw.99d3fb7b.png";